import { RESET_STATE, SET_ORDERS_IMPORTS_LIST, SET_IS_ORDERS_IMPORTS_LIST_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	ordersImportsList: null,
	isOrdersImportsListLoading: false,
	pagination: null,
};

const ordersImportsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ORDERS_IMPORTS_LIST:
			return {
				...state,
				ordersImportsList: payload,
			};
		case SET_IS_ORDERS_IMPORTS_LIST_LOADING:
			return {
				...state,
				isOrdersImportsListLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersImportsContainerReducer;
